import { jsx } from "react/jsx-runtime";
import { useContext, createContext, useMemo } from "react";
const AddressAutofillContext = createContext({
  onAddressSelect: () => {
  }
});
const AddressAutofillProvider = ({
  children,
  onAddressSelect,
  autocompleteEnabled
}) => {
  const value = useMemo(
    () => ({ onAddressSelect, autocompleteEnabled }),
    [onAddressSelect, autocompleteEnabled]
  );
  return /* @__PURE__ */ jsx(AddressAutofillContext.Provider, { value, children });
};
function useAddressAutofill() {
  return useContext(AddressAutofillContext);
}
export {
  AddressAutofillProvider,
  useAddressAutofill
};
//# sourceMappingURL=address-autofill-context.js.map
